"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageBubble = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var index_1 = require("../../../index");
var StyledDiv = (0, styled_components_1.default)("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: ", "px;\n  overflow: hidden;\n  position: relative;\n  .children-list {\n    padding: 0;\n    margin: 0;\n    position: absolute;\n    left: 10px;\n    top: 10px;\n    width: calc(100% - 20px);\n    height: calc(100% - 20px);\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: stretch;\n    align-content: flex-end;\n  }\n"], ["\n  border-radius: ", "px;\n  overflow: hidden;\n  position: relative;\n  .children-list {\n    padding: 0;\n    margin: 0;\n    position: absolute;\n    left: 10px;\n    top: 10px;\n    width: calc(100% - 20px);\n    height: calc(100% - 20px);\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: stretch;\n    align-content: flex-end;\n  }\n"])), function (props) { var _a; return ((_a = props.theme) === null || _a === void 0 ? void 0 : _a.cardRadius) || 0; });
var ImageBubble = function (_a) {
    var props = __rest(_a, []);
    var children = props.children, image = props.image, _b = props.ratio, ratio = _b === void 0 ? 1 : _b, header = props.header, _c = props.className, className = _c === void 0 ? "" : _c;
    return ((0, jsx_runtime_1.jsxs)(StyledDiv, __assign({}, props, { className: "wellms-component ".concat(className) }, { children: [(0, jsx_runtime_1.jsx)(index_1.RatioBox, __assign({ ratio: ratio }, { children: React.isValidElement(image) ? ((0, jsx_runtime_1.jsx)(React.Fragment, { children: image })) : ((0, jsx_runtime_1.jsx)("img", { className: "banner-img", src: image.src, alt: image.alt })) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "children-list" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "children-list__header" }, { children: header || " " })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "children-list__items" }, { children: children }))] }))] })));
};
exports.ImageBubble = ImageBubble;
// Main button with styles
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(exports.ImageBubble)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""]))));
var templateObject_1, templateObject_2;
